/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentsCreateClaim/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CancelAction from './CancelAction/index'
import Charges from './Charges/index'
import DueDate from './DueDate/index'
import Notes from './Notes/index'
import PaymentAccount from 'DesignSystem/PaymentAccount/index'
import PaymentAccountFilter from 'DesignSystem/PaymentAccount/PaymentAccountFilter/index'
import PaymentAccountSelect from 'DesignSystem/PaymentAccount/PaymentAccountSelect/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import Treatment from './Treatment/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentsCreateClaim({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim",
  onChange
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let messageParamsPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'message',
path: 'params.patient_id',
})
let createClaimDefaultPaymentAccountIdValueData = fromData.useDataValue({ viewPath,
context: 'create_claim',
path: 'default_payment_account_id',
})
let createClaimPaymentAccountChangeData = fromData.useDataChange({ viewPath,
context: 'create_claim',
path: 'payment_account',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="large"
 height={800}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Create claim"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 gap={dtSpaceM}
>
{childProps => (
<React.Fragment>
<PaymentAccount
{...childProps}
  viewPath={`${viewPath}/PaymentAccount`}
 data="message.params.patient_id"
 patientId={messageParamsPatientIdValueData}
 data="create_claim.default_payment_account_id"
 defaultPaymentAccountId={createClaimDefaultPaymentAccountIdValueData}
 data="create_claim.payment_account"
 onChange={createClaimPaymentAccountChangeData}
 includePersonPayors={false}
>
{childProps => (
<div
  data-testid="PaymentsCreateClaim.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-18x7uk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PaymentsCreateClaim.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaSelectOneLabel
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Payor account"
/>
<PaymentAccountFilter
  viewPath={`${viewPath}/PaymentAccountFilter`}
/>
</div>
<PaymentAccountSelect
  viewPath={`${viewPath}/PaymentAccountSelect`}
/>
</div>
)}
</PaymentAccount>
<div
  data-testid="PaymentsCreateClaim.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-18x7uk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Treatment
  viewPath={`${viewPath}/Treatment`}
/>
<DueDate
  viewPath={`${viewPath}/DueDate`}
/>
</div>
<Notes
{...childProps}
  viewPath={`${viewPath}/Notes`}
/>
<Charges
{...childProps}
  viewPath={`${viewPath}/Charges`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SaveAction
{...childProps}
  viewPath={`${viewPath}/SaveAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}